module.exports = __webpack_public_path__ + "static/media/S2N11-5.cddf62ef.svg";